module.exports = __webpack_public_path__ + "img/huangjin@2x.d89c8639.png";